import index from './'
import token from './token'
import tokengoogle from './tokengoogle'
import selfie from './selfie'
import email from './email'
import menu from './menu'

export default [
  {
    path: '/auth/login',
    name: 'auth.index',
    component: index
  },
  {
    path: '/auth/verificacao',
    name: 'auth.verificacao',
    component: token
  },
  {
    path: '/auth/verificacaogoogle',
    name: 'auth.verificacaogoogle',
    component: tokengoogle
  },
  {
    path: '/auth/selfie',
    name: 'auth.selfie',
    component: selfie
  },
  {
    path: '/auth/email',
    name: 'auth.email',
    component: email
  },
  {
    path: '/menu',
    name: 'menu.index',
    component: menu
  }
]



// WEBPACK FOOTER //
// ./src/features/auth/routes.js